module.exports = __webpack_public_path__ + "media/images/brand/logo/tfs_logo-cb7a52999a9300e203e36865dc428f71.svg";